import React from 'react';
import { VCredit } from '../keno/VCredit';
import { toMinor } from '../keno/credits';

export const profitOnWin = (game) => {
  const amount = toMinor(game.bet);
  if (!amount) return 0;
  let multiplier;
  if (game.gameType === 'limbo') {
    const target = Number(game.targetMultiplier);
    if (!Number.isFinite(target) || target < 1.01 || target > 1000000) return null;
    multiplier = BigInt(Math.round(target * 100000000));
  } else {
    const target = Math.round(Number(game.target) * 100);
    const count = game.direction === 'under' ? target : 9999 - target;
    if (game.target === '' || !Number.isFinite(count) || count < 1 || count > 9800) return null;
    multiplier = 10000n * 99000000n / BigInt(count);
  }
  // Match the resolver's integer multiplier and payout flooring, not rounded odds.
  const profit = BigInt(amount) * multiplier / 100000000n - BigInt(amount);
  return profit <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(profit) : null;
};

export const OriginalWinProfit = ({ game }) => {
  const profit = profitOnWin(game);
  return <div className="original-win-profit" data-testid={`${game.gameType}-profit-on-win`}>
    <span className="original-profit-label" id={`${game.gameType}-profit-label`}>Profit on Win</span>
    <output aria-labelledby={`${game.gameType}-profit-label`} data-testid={`${game.gameType}-profit-output`}>
      {profit === null ? <span data-testid={`${game.gameType}-profit-unavailable`}>—</span> : <VCredit minor={profit} testid={`${game.gameType}-profit-value`} />}
    </output>
  </div>;
};